import React from 'react';
import PropTypes from 'prop-types';
import angularChat from '../../images/angularChat.jpg';
import goReactChat from '../../images/go:reactChat.png';
import loginApp from '../../images/login-app.jpg';
import project from '../../images/project.jpg';
import todoApp from '../../images/todo-app.jpg';

const projectImages = {
  'angularChat.jpg': angularChat,
  'go:reactChat.png': goReactChat,
  'login-app.jpg': loginApp,
  'project.jpg': project,
  'todo-app.jpg': todoApp,
};

const ProjectImg = ({ filename, alt }) => {
  const image = projectImages[filename];

  if (!image) return null;

  return <img className="img-fluid" src={image} alt={alt} />;
};

ProjectImg.propTypes = {
  filename: PropTypes.string,
  alt: PropTypes.string,
};

export default ProjectImg;
